<template>
  <div class="ap">
    <div v-if="loading" class="ap-note">Loading…</div>
    <div v-else-if="error" class="ap-note ap-error">{{ error }}</div>
    <template v-else>
      <div class="ap-head">
        <div>
          <div class="ap-title">{{ page.title }}</div>
          <div v-if="page.description" class="ap-desc">{{ page.description }}</div>
        </div>
        <div class="ap-meta">Saved {{ when }}</div>
      </div>
      <PageCanvas
        v-if="isSpec"
        :slug="slug"
        :spec="page.spec"
        :widgets="page.widgets || {}"
        :can-edit="!!page.can_edit"
        @saved="onSaved"
      />
      <AgentHtmlCard
        v-else
        :html="page.html"
        :sources="page.sources || []"
        :page-slug="slug"
        class="sensitive"
        data-demo-blur
      />
    </template>
  </div>
</template>

<script>
import axios from 'axios';
import AgentHtmlCard from './AgentHtmlCard.vue';
import PageCanvas from './widgets/PageCanvas.vue';

export default {
  name: 'AgentPageView',
  components: { AgentHtmlCard, PageCanvas },
  props: { slug: { type: String, required: true } },
  data() {
    return { page: null, loading: true, error: '' };
  },
  computed: {
    when() {
      if (!this.page?.updated_at) return '';
      return new Date(this.page.updated_at).toLocaleString([], {
        month: 'short', day: 'numeric', hour: 'numeric', minute: '2-digit',
      });
    },
    isSpec() {
      return !!(this.page && this.page.spec && (this.page.spec.placements || []).length);
    },
  },
  async mounted() {
    await this.load();
  },
  methods: {
    async load() {
      try {
        const { data } = await axios.get(`/api/impact_analytics/agent-pages/${this.slug}/`);
        this.page = data;
        document.title = `${data.title} | Kairon Health`;
      } catch (error) {
        this.error = error?.response?.status === 404
          ? 'No page with that name.'
          : 'That page could not be loaded.';
      } finally {
        this.loading = false;
      }
    },
    onSaved(data) {
      this.page = { ...this.page, ...data };
    },
  },
};
</script>

<style scoped>
.ap { padding: 24px; background: #f6f5f3; min-height: 100%; }
.ap-head { display: flex; align-items: flex-start; justify-content: space-between; gap: 16px; margin-bottom: 16px; }
.ap-title { font-size: 18px; font-weight: 600; color: #1a1918; }
.ap-desc { font-size: 13px; color: #56534d; margin-top: 2px; }
.ap-meta { font-size: 11.5px; color: #8b877f; white-space: nowrap; }
.ap-note { padding: 32px; font-size: 13px; color: #56534d; }
.ap-error { color: #c23a28; }
</style>
